/* Generated by ai2react v0.102.0 - 2021-09-14 02:51 */
/* ai file: 02-qs-world.ai */

import { makeAi2React } from './src/index'
import img0 from './img/02-qs-world-large.svg'
import img1 from './img/02-qs-world-mobile.svg'

const styles = `
  #g-02-qs-world-box ,
  #g-02-qs-world-box .g-artboard {
    margin:0 auto;
  }
  #g-02-qs-world-box p {
    margin:0;
  }
  #g-02-qs-world-box .g-aiAbs {
    position:absolute;
  }
  #g-02-qs-world-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-02-qs-world-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-02-qs-world-box .g-aiPointText p { white-space: nowrap; }
  #g-02-qs-world-large {
    position:relative;
    overflow:hidden;
  }
  #g-02-qs-world-large p {
    font-family:Inter;
    font-weight:400;
    line-height:12px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-02-qs-world-large .g-pstyle0 {
    font-weight:800;
    line-height:21px;
    height:21px;
    letter-spacing:-0.02em;
    font-size:18px;
  }
  #g-02-qs-world-large .g-pstyle1 {
    font-weight:800;
    line-height:13px;
    height:13px;
    letter-spacing:-0.019em;
    font-size:11px;
    color:rgb(252,184,19);
  }
  #g-02-qs-world-large .g-pstyle2 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-02-qs-world-large .g-pstyle3 {
    font-weight:800;
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:8px;
  }
  #g-02-qs-world-large .g-pstyle4 {
    height:12px;
  }
  #g-02-qs-world-large .g-pstyle5 {
    line-height:11px;
    height:11px;
    font-size:9px;
  }
  #g-02-qs-world-large .g-pstyle6 {
    font-weight:800;
    line-height:11px;
    height:11px;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-02-qs-world-large .g-pstyle7 {
    font-weight:800;
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-02-qs-world-large .g-pstyle8 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
  }
  #g-02-qs-world-large .g-pstyle9 {
    height:12px;
    letter-spacing:-0.03em;
  }
  #g-02-qs-world-large .g-pstyle10 {
    line-height:13px;
    height:13px;
    font-size:11px;
  }
  #g-02-qs-world-large .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-02-qs-world-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-02-qs-world-large .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-02-qs-world-large .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-02-qs-world-large .g-cstyle4 {
    letter-spacing:-0.116em;
  }
  #g-02-qs-world-large .g-cstyle5 {
    letter-spacing:-0.014em;
  }
  #g-02-qs-world-large .g-cstyle6 {
    letter-spacing:0.213em;
  }
  #g-02-qs-world-large .g-cstyle7 {
    letter-spacing:-0.032em;
  }
  #g-02-qs-world-large .g-cstyle8 {
    letter-spacing:-0.033em;
  }
  #g-02-qs-world-large .g-cstyle9 {
    letter-spacing:-0.029em;
  }
  #g-02-qs-world-large .g-cstyle10 {
    letter-spacing:-0.047em;
  }
  #g-02-qs-world-large .g-cstyle11 {
    letter-spacing:-0.034em;
  }
  #g-02-qs-world-large .g-cstyle12 {
    letter-spacing:-0.043em;
  }
  #g-02-qs-world-large .g-cstyle13 {
    letter-spacing:-0.036em;
  }
  #g-02-qs-world-large .g-cstyle14 {
    letter-spacing:-0.09em;
  }
  #g-02-qs-world-large .g-cstyle15 {
    letter-spacing:-0.086em;
  }
  #g-02-qs-world-large .g-cstyle16 {
    letter-spacing:-0.035em;
  }
  #g-02-qs-world-large .g-cstyle17 {
    letter-spacing:-0.049em;
  }
  #g-02-qs-world-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-02-qs-world-mobile p {
    font-family:Inter;
    font-weight:400;
    line-height:12px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-02-qs-world-mobile .g-pstyle0 {
    font-weight:800;
    line-height:26px;
    height:26px;
    letter-spacing:-0.02em;
    font-size:22px;
  }
  #g-02-qs-world-mobile .g-pstyle1 {
    font-weight:800;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-02-qs-world-mobile .g-pstyle2 {
    font-weight:800;
    line-height:13px;
    height:13px;
    letter-spacing:-0.019em;
    font-size:11px;
    color:rgb(252,184,19);
  }
  #g-02-qs-world-mobile .g-pstyle3 {
    font-weight:800;
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:8px;
  }
  #g-02-qs-world-mobile .g-pstyle4 {
    height:12px;
  }
  #g-02-qs-world-mobile .g-pstyle5 {
    height:12px;
    letter-spacing:-0.03em;
  }
  #g-02-qs-world-mobile .g-pstyle6 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
  }
  #g-02-qs-world-mobile .g-pstyle7 {
    font-weight:800;
    line-height:11px;
    height:11px;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-02-qs-world-mobile .g-pstyle8 {
    font-weight:800;
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-02-qs-world-mobile .g-pstyle9 {
    line-height:11px;
    height:11px;
    font-size:9px;
  }
  #g-02-qs-world-mobile .g-pstyle10 {
    line-height:13px;
    height:13px;
    font-size:11px;
  }
  #g-02-qs-world-mobile .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-02-qs-world-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-02-qs-world-mobile .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-02-qs-world-mobile .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-02-qs-world-mobile .g-cstyle4 {
    letter-spacing:-0.116em;
  }
  #g-02-qs-world-mobile .g-cstyle5 {
    letter-spacing:-0.029em;
  }
  #g-02-qs-world-mobile .g-cstyle6 {
    letter-spacing:-0.014em;
  }
  #g-02-qs-world-mobile .g-cstyle7 {
    letter-spacing:0.213em;
  }
  #g-02-qs-world-mobile .g-cstyle8 {
    letter-spacing:-0.032em;
  }
  #g-02-qs-world-mobile .g-cstyle9 {
    letter-spacing:-0.033em;
  }
  #g-02-qs-world-mobile .g-cstyle10 {
    letter-spacing:-0.047em;
  }
  #g-02-qs-world-mobile .g-cstyle11 {
    letter-spacing:-0.034em;
  }
  #g-02-qs-world-mobile .g-cstyle12 {
    letter-spacing:-0.043em;
  }
  #g-02-qs-world-mobile .g-cstyle13 {
    letter-spacing:-0.036em;
  }
  #g-02-qs-world-mobile .g-cstyle14 {
    letter-spacing:-0.09em;
  }
  #g-02-qs-world-mobile .g-cstyle15 {
    letter-spacing:-0.086em;
  }
  #g-02-qs-world-mobile .g-cstyle16 {
    letter-spacing:-0.035em;
  }
  #g-02-qs-world-mobile .g-cstyle17 {
    letter-spacing:-0.049em;
  }

`

const html = props => `
<div id="g-02-qs-world-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-02-qs-world-large" class="g-artboard" style="width:800px; height:456.000000000018px;" data-aspect-ratio="1.754" data-min-width="800">
<div style=""></div>
    <img id="g-02-qs-world-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:4.1362%;margin-top:-11.9px;left:1.6879%;width:365px;">
      <p class="g-pstyle0">QS <span class="g-cstyle0">W</span>ORLD U<span class="g-cstyle0">N</span>IV<span class="g-cstyle0">E</span>RSI<span class="g-cstyle0">TY</span> RANKI<span class="g-cstyle0">N</span>GS 202<span class="g-cstyle1">2</span></p>
    </div>
    <div id="g-ai0-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.0388%;margin-top:-7.2px;left:8.3501%;width:76px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:9.1066%;margin-top:-6.5px;left:2.2341%;width:66px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.9551%;margin-top:-5.8px;left:51.8878%;width:39px;">
      <p class="g-pstyle3">Pa<span class="g-cstyle2">í</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.9551%;margin-top:-5.8px;left:80.5904%;width:54px;">
      <p class="g-pstyle3">Pun<span class="g-cstyle2">ta</span>je<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.0803%;margin-top:-6.5px;left:2.2341%;width:65px;">
      <p class="g-pstyle2">MU<span class="g-cstyle0">N</span>DIA<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.077%;margin-top:-6.9px;left:9.9882%;width:226px;">
      <p class="g-pstyle4">In<span class="g-cstyle3">s</span>ti<span class="g-cstyle3">t</span>uto <span class="g-cstyle4">T</span>e<span class="g-cstyle3">c</span>nológ<span class="g-cstyle3">i</span>c<span class="g-cstyle3">o</span> d<span class="g-cstyle3">e</span> <span class="g-cstyle3">Ma</span>s<span class="g-cstyle3">sac</span>hu<span class="g-cstyle3">se</span>tt<span class="g-cstyle3">s </span>(<span class="g-cstyle3">M</span>I<span class="g-cstyle5">T</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.4399%;margin-top:-6.5px;left:46.2615%;width:141px;">
      <p class="g-pstyle5"><span class="g-cstyle6"> </span>Cam<span class="g-cstyle3">b</span>r<span class="g-cstyle3">id</span>ge, E<span class="g-cstyle3">s</span>ta<span class="g-cstyle3">dos</span> <span class="g-cstyle7">U</span><span class="g-cstyle3">ni</span>d<span class="g-cstyle3">os</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.4399%;margin-top:-6.5px;left:67.0292%;width:41px;">
      <p class="g-pstyle6">1<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:17.2884%;margin-top:-5.8px;left:4.7493%;width:28px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai0-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.7525%;margin-top:-6.9px;left:9.9882%;width:124px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">rs</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> d<span class="g-cstyle3">e </span>O<span class="g-cstyle3">x</span>fo<span class="g-cstyle3">rd</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.1154%;margin-top:-6.5px;left:46.2615%;width:110px;">
      <p class="g-pstyle8"><span class="g-cstyle6"> </span><span class="g-cstyle9">O</span>xfo<span class="g-cstyle9">r</span>d<span class="g-cstyle9">,</span> <span class="g-cstyle9">R</span>eino<span class="g-cstyle9"> </span><span class="g-cstyle7">U</span>n<span class="g-cstyle9">i</span>do<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.1154%;margin-top:-6.5px;left:66.7642%;width:44px;">
      <p class="g-pstyle6">9<span class="g-cstyle10">9</span><span class="g-cstyle3">,</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.9639%;margin-top:-5.8px;left:4.7249%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle2">2</span> </p>
    </div>
    <div id="g-ai0-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.4279%;margin-top:-6.9px;left:9.9882%;width:132px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">rs</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> d<span class="g-cstyle3">e </span><span class="g-cstyle7">S</span>ta<span class="g-cstyle8">n</span><span class="g-cstyle3">f</span>o<span class="g-cstyle3">r</span>d<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.7908%;margin-top:-6.5px;left:46.2615%;width:132px;">
      <p class="g-pstyle8"><span class="g-cstyle6"> </span><span class="g-cstyle7">S</span><span class="g-cstyle9">ta</span><span class="g-cstyle8">n</span><span class="g-cstyle9">f</span>or<span class="g-cstyle9">d, </span>E<span class="g-cstyle9">s</span>t<span class="g-cstyle9">a</span>dos<span class="g-cstyle9"> </span><span class="g-cstyle7">U</span>n<span class="g-cstyle9">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.7908%;margin-top:-6.5px;left:66.7813%;width:43px;">
      <p class="g-pstyle6">9<span class="g-cstyle11">8</span><span class="g-cstyle12">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.6393%;margin-top:-5.8px;left:4.733%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai0-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.1034%;margin-top:-6.9px;left:9.9882%;width:143px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">rs</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> d<span class="g-cstyle3">e </span>C<span class="g-cstyle3">a</span>mb<span class="g-cstyle3">r</span>idg<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.4663%;margin-top:-6.5px;left:46.2615%;width:127px;">
      <p class="g-pstyle5"><span class="g-cstyle6"> </span>Cam<span class="g-cstyle3">b</span>r<span class="g-cstyle3">id</span>ge, Re<span class="g-cstyle3">ino</span> <span class="g-cstyle7">U</span><span class="g-cstyle3">n</span>i<span class="g-cstyle3">do</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.4663%;margin-top:-6.5px;left:66.7813%;width:43px;">
      <p class="g-pstyle6">9<span class="g-cstyle11">8</span><span class="g-cstyle12">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.3147%;margin-top:-5.8px;left:4.733%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai0-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.7788%;margin-top:-6.9px;left:9.9882%;width:129px;">
      <p class="g-pstyle9"><span class="g-cstyle8">U</span><span class="g-cstyle9">ni</span>v<span class="g-cstyle9">e</span>rs<span class="g-cstyle9">i</span>d<span class="g-cstyle9">a</span>d<span class="g-cstyle9"> d</span>e H<span class="g-cstyle9">a</span>rv<span class="g-cstyle9">a</span>rd<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.1417%;margin-top:-6.5px;left:46.2615%;width:141px;">
      <p class="g-pstyle5"><span class="g-cstyle6"> </span>Cam<span class="g-cstyle3">b</span>r<span class="g-cstyle3">id</span>ge, E<span class="g-cstyle3">s</span>ta<span class="g-cstyle3">dos</span> <span class="g-cstyle7">U</span><span class="g-cstyle3">ni</span>d<span class="g-cstyle3">os</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.1417%;margin-top:-6.5px;left:66.6907%;width:44px;">
      <p class="g-pstyle6">9<span class="g-cstyle11">8</span><span class="g-cstyle13">,</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.9902%;margin-top:-5.8px;left:4.733%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai0-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.4542%;margin-top:-6.9px;left:9.9882%;width:227px;">
      <p class="g-pstyle4">In<span class="g-cstyle3">s</span>ti<span class="g-cstyle3">t</span>uto <span class="g-cstyle4">T</span>e<span class="g-cstyle3">c</span>nológ<span class="g-cstyle3">i</span>c<span class="g-cstyle3">o</span> d<span class="g-cstyle3">e</span> Cali<span class="g-cstyle3">f</span>o<span class="g-cstyle3">r</span>nia <span class="g-cstyle3">(</span>CA<span class="g-cstyle14">L</span>T<span class="g-cstyle11">E</span>C<span class="g-cstyle3">H</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.8171%;margin-top:-6.5px;left:46.2615%;width:136px;">
      <p class="g-pstyle8"><span class="g-cstyle6"> </span><span class="g-cstyle9">P</span>a<span class="g-cstyle9">s</span>a<span class="g-cstyle9">d</span>e<span class="g-cstyle9">na, </span>Es<span class="g-cstyle9">ta</span>dos<span class="g-cstyle9"> </span><span class="g-cstyle7">U</span>ni<span class="g-cstyle9">d</span>os<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.8171%;margin-top:-6.5px;left:66.8062%;width:43px;">
      <p class="g-pstyle6">9<span class="g-cstyle15">7</span><span class="g-cstyle3">,</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.6656%;margin-top:-5.8px;left:4.7167%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">6</span> </p>
    </div>
    <div id="g-ai0-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.1297%;margin-top:-6.9px;left:9.9882%;width:131px;">
      <p class="g-pstyle4">Imp<span class="g-cstyle3">e</span>r<span class="g-cstyle3">i</span>al Coll<span class="g-cstyle3">e</span>ge Lon<span class="g-cstyle3">do</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.4926%;margin-top:-6.5px;left:46.2615%;width:115px;">
      <p class="g-pstyle8"><span class="g-cstyle6"> </span><span class="g-cstyle9">L</span>on<span class="g-cstyle9">d</span><span class="g-cstyle7">r</span>es<span class="g-cstyle9">,</span> <span class="g-cstyle9">Re</span>ino<span class="g-cstyle9"> </span><span class="g-cstyle7">U</span>n<span class="g-cstyle9">i</span>do<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.4926%;margin-top:-6.5px;left:66.8638%;width:43px;">
      <p class="g-pstyle6">9<span class="g-cstyle15">7</span><span class="g-cstyle3">,</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.3411%;margin-top:-5.8px;left:4.7412%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai0-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.8051%;margin-top:-6.9px;left:9.9882%;width:76px;">
      <p class="g-pstyle4"><span class="g-cstyle3">E</span>T<span class="g-cstyle3">H</span> <span class="g-cstyle7">Z</span>ur<span class="g-cstyle3">ich</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.168%;margin-top:-6.5px;left:46.2615%;width:81px;">
      <p class="g-pstyle5"><span class="g-cstyle6"> </span><span class="g-cstyle7">Z</span>ur<span class="g-cstyle3">i</span>c<span class="g-cstyle3">h</span>, <span class="g-cstyle3">S</span>ui<span class="g-cstyle3">z</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.168%;margin-top:-6.5px;left:66.7234%;width:44px;">
      <p class="g-pstyle6">95<span class="g-cstyle3">,</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.0165%;margin-top:-5.8px;left:4.7167%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai0-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.4806%;margin-top:-6.9px;left:9.9882%;width:44px;">
      <p class="g-pstyle4">UCL<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.8434%;margin-top:-6.5px;left:46.2615%;width:115px;">
      <p class="g-pstyle8"><span class="g-cstyle6"> </span><span class="g-cstyle9">L</span>on<span class="g-cstyle9">d</span><span class="g-cstyle7">r</span>es<span class="g-cstyle9">,</span> <span class="g-cstyle9">Re</span>ino<span class="g-cstyle9"> </span><span class="g-cstyle7">U</span>n<span class="g-cstyle9">i</span>do<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.8434%;margin-top:-6.5px;left:66.7234%;width:44px;">
      <p class="g-pstyle6">95<span class="g-cstyle3">,</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.692%;margin-top:-5.8px;left:4.7167%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai0-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.156%;margin-top:-6.9px;left:9.9882%;width:128px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">rs</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> d<span class="g-cstyle3">e </span>Ch<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a</span>g<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai0-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.5188%;margin-top:-6.5px;left:46.2615%;width:128px;">
      <p class="g-pstyle5"><span class="g-cstyle6"> </span>Ch<span class="g-cstyle3">i</span>cag<span class="g-cstyle3">o,</span> E<span class="g-cstyle3">s</span>ta<span class="g-cstyle3">dos</span> <span class="g-cstyle7">U</span><span class="g-cstyle3">ni</span>d<span class="g-cstyle3">o</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.5188%;margin-top:-6.5px;left:66.7234%;width:42px;">
      <p class="g-pstyle6">9<span class="g-cstyle13">4</span>,<span class="g-cstyle1">5</span></p>
    </div>
    <div id="g-ai0-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.3674%;margin-top:-5.8px;left:4.4358%;width:32px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>0</p>
    </div>
    <div id="g-ai0-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:94.5651%;margin-top:-7.2px;left:1.6797%;width:241px;">
      <p class="g-pstyle10">(*) <span class="g-cstyle16">F</span>u<span class="g-cstyle3">e</span>nt<span class="g-cstyle3">e</span>: <span class="g-cstyle3">Q</span>S <span class="g-cstyle17">W</span>or<span class="g-cstyle3">ld</span> <span class="g-cstyle8">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>t<span class="g-cstyle3">y</span> R<span class="g-cstyle3">a</span>nk<span class="g-cstyle3">i</span>ng<span class="g-cstyle3">s </span>2<span class="g-cstyle3">0</span>2<span class="g-cstyle1">2</span></p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-02-qs-world-mobile" class="g-artboard" style="max-width: 320px;max-height: 499px" data-aspect-ratio="0.641" data-min-width="0" data-max-width="799">
<div style="padding: 0 0 155.9375% 0;"></div>
    <img id="g-02-qs-world-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:6.7476%;margin-top:-27.7px;left:1.407%;width:273px;">
      <p class="g-pstyle0">QS <span class="g-cstyle0">W</span>ORLD U<span class="g-cstyle0">N</span>IV<span class="g-cstyle0">E</span>RSI<span class="g-cstyle0">TY</span> </p>
      <p class="g-pstyle0">RANKI<span class="g-cstyle0">N</span>GS 202<span class="g-cstyle1">2</span></p>
    </div>
    <div id="g-ai1-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:14.1335%;margin-top:-6.5px;left:1.8352%;width:66px;">
      <p class="g-pstyle1">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:14.8731%;margin-top:-7.2px;left:18.0627%;width:76px;">
      <p class="g-pstyle2"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:14.997%;margin-top:-5.8px;left:59.0944%;width:39px;">
      <p class="g-pstyle3">Pa<span class="g-cstyle2">í</span><span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.1974%;margin-top:-5.8px;left:83.6635%;width:54px;">
      <p class="g-pstyle3">Pun<span class="g-cstyle2">ta</span>je<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.9371%;margin-top:-6.5px;left:1.8352%;width:65px;">
      <p class="g-pstyle1">MU<span class="g-cstyle0">N</span>DIA<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai1-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:21.6084%;margin-top:-12.8px;left:8.7204%;width:130px;">
      <p class="g-pstyle4">In<span class="g-cstyle3">s</span>ti<span class="g-cstyle3">t</span>uto <span class="g-cstyle4">T</span>e<span class="g-cstyle3">c</span>nológ<span class="g-cstyle3">i</span>c<span class="g-cstyle3">o</span> d<span class="g-cstyle3">e</span> </p>
      <p class="g-pstyle5">Massachusetts <span class="g-cstyle5">(</span>M<span class="g-cstyle5">I</span><span class="g-cstyle6">T</span><span class="g-cstyle5">)</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:21.7487%;margin-top:-6.5px;left:53.4663%;width:92px;">
      <p class="g-pstyle6"><span class="g-cstyle7"> </span><span class="g-cstyle5">E</span>s<span class="g-cstyle5">ta</span>dos<span class="g-cstyle5"> </span><span class="g-cstyle8">U</span>ni<span class="g-cstyle5">d</span>os<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:21.7487%;margin-top:-6.5px;left:77.8856%;width:41px;">
      <p class="g-pstyle7">1<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:21.6103%;margin-top:-5.8px;left:3.7482%;width:28px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span> </p>
    </div>
    <div id="g-ai1-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.4311%;margin-top:-6.9px;left:8.7204%;width:124px;">
      <p class="g-pstyle4"><span class="g-cstyle9">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">rs</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> d<span class="g-cstyle3">e </span>O<span class="g-cstyle3">x</span>fo<span class="g-cstyle3">rd</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.7628%;margin-top:-6.5px;left:54.4038%;width:73px;">
      <p class="g-pstyle6"><span class="g-cstyle5">R</span>eino<span class="g-cstyle5"> </span><span class="g-cstyle8">U</span>n<span class="g-cstyle5">i</span>do<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.7628%;margin-top:-6.5px;left:77.2231%;width:44px;">
      <p class="g-pstyle7">9<span class="g-cstyle10">9</span><span class="g-cstyle3">,</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.6243%;margin-top:-5.8px;left:3.6871%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle2">2</span> </p>
    </div>
    <div id="g-ai1-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.4452%;margin-top:-6.9px;left:8.7204%;width:132px;">
      <p class="g-pstyle4"><span class="g-cstyle9">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">rs</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> d<span class="g-cstyle3">e </span><span class="g-cstyle8">S</span>ta<span class="g-cstyle9">n</span><span class="g-cstyle3">f</span>o<span class="g-cstyle3">r</span>d<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.7768%;margin-top:-6.5px;left:54.4038%;width:88px;">
      <p class="g-pstyle6">E<span class="g-cstyle5">s</span>t<span class="g-cstyle5">a</span>dos<span class="g-cstyle5"> </span><span class="g-cstyle8">U</span>n<span class="g-cstyle5">i</span>dos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.7768%;margin-top:-6.5px;left:77.2658%;width:43px;">
      <p class="g-pstyle7">9<span class="g-cstyle11">8</span><span class="g-cstyle12">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:35.6383%;margin-top:-5.8px;left:3.7076%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai1-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.2497%;margin-top:-12.8px;left:8.7204%;width:91px;">
      <p class="g-pstyle4"><span class="g-cstyle9">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">rs</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> d<span class="g-cstyle3">e </span></p>
      <p class="g-pstyle4">C<span class="g-cstyle3">a</span>mb<span class="g-cstyle3">r</span>idg<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.7908%;margin-top:-6.5px;left:54.4038%;width:73px;">
      <p class="g-pstyle6"><span class="g-cstyle5">Re</span>ino<span class="g-cstyle5"> </span><span class="g-cstyle8">U</span>n<span class="g-cstyle5">i</span>do<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.7908%;margin-top:-6.5px;left:77.2658%;width:43px;">
      <p class="g-pstyle7">9<span class="g-cstyle11">8</span><span class="g-cstyle12">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.6523%;margin-top:-5.8px;left:3.7076%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai1-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.4732%;margin-top:-6.9px;left:8.7204%;width:129px;">
      <p class="g-pstyle5"><span class="g-cstyle9">U</span><span class="g-cstyle5">ni</span>v<span class="g-cstyle5">e</span>rs<span class="g-cstyle5">i</span>d<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> d</span>e H<span class="g-cstyle5">a</span>rv<span class="g-cstyle5">a</span>rd<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.8048%;margin-top:-6.5px;left:54.4038%;width:88px;">
      <p class="g-pstyle6"><span class="g-cstyle5">E</span>s<span class="g-cstyle5">ta</span>dos<span class="g-cstyle5"> </span><span class="g-cstyle8">U</span>ni<span class="g-cstyle5">d</span>os<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.8048%;margin-top:-6.5px;left:77.0393%;width:44px;">
      <p class="g-pstyle7">9<span class="g-cstyle11">8</span><span class="g-cstyle13">,</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.6664%;margin-top:-5.8px;left:3.7076%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai1-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.2777%;margin-top:-12.8px;left:8.7204%;width:128px;">
      <p class="g-pstyle4">In<span class="g-cstyle3">s</span>ti<span class="g-cstyle3">t</span>uto <span class="g-cstyle4">T</span>e<span class="g-cstyle3">c</span>nológ<span class="g-cstyle3">i</span>c<span class="g-cstyle3">o</span> d<span class="g-cstyle3">e</span></p>
      <p class="g-pstyle4">Cali<span class="g-cstyle3">f</span>o<span class="g-cstyle3">r</span>nia <span class="g-cstyle3">(</span>CA<span class="g-cstyle14">L</span>T<span class="g-cstyle11">E</span>C<span class="g-cstyle3">H</span>)<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.8189%;margin-top:-6.5px;left:54.4038%;width:88px;">
      <p class="g-pstyle6">Es<span class="g-cstyle5">ta</span>dos<span class="g-cstyle5"> </span><span class="g-cstyle8">U</span>ni<span class="g-cstyle5">d</span>os<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.8189%;margin-top:-6.5px;left:77.328%;width:43px;">
      <p class="g-pstyle7">9<span class="g-cstyle15">7</span><span class="g-cstyle3">,</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.6804%;margin-top:-5.8px;left:3.6667%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">6</span> </p>
    </div>
    <div id="g-ai1-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.5013%;margin-top:-6.9px;left:8.7204%;width:131px;">
      <p class="g-pstyle4">Imp<span class="g-cstyle3">e</span>r<span class="g-cstyle3">i</span>al Coll<span class="g-cstyle3">e</span>ge Lon<span class="g-cstyle3">do</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.8329%;margin-top:-6.5px;left:54.4038%;width:73px;">
      <p class="g-pstyle6"><span class="g-cstyle5">Re</span>ino<span class="g-cstyle5"> </span><span class="g-cstyle8">U</span>n<span class="g-cstyle5">i</span>do<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.8329%;margin-top:-6.5px;left:77.4721%;width:43px;">
      <p class="g-pstyle7">9<span class="g-cstyle15">7</span><span class="g-cstyle3">,</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.6944%;margin-top:-5.8px;left:3.728%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai1-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.5153%;margin-top:-6.9px;left:8.7204%;width:76px;">
      <p class="g-pstyle4"><span class="g-cstyle3">E</span>T<span class="g-cstyle3">H</span> <span class="g-cstyle8">Z</span>ur<span class="g-cstyle3">ich</span> <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.8469%;margin-top:-6.5px;left:54.4038%;width:46px;">
      <p class="g-pstyle9"><span class="g-cstyle3">S</span>ui<span class="g-cstyle3">z</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.8469%;margin-top:-6.5px;left:77.1211%;width:44px;">
      <p class="g-pstyle7">95<span class="g-cstyle3">,</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.7085%;margin-top:-5.8px;left:3.6667%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai1-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.5293%;margin-top:-6.9px;left:8.7204%;width:44px;">
      <p class="g-pstyle4">UCL<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.8609%;margin-top:-6.5px;left:54.4038%;width:73px;">
      <p class="g-pstyle6"><span class="g-cstyle5">Re</span>ino<span class="g-cstyle5"> </span><span class="g-cstyle8">U</span>n<span class="g-cstyle5">i</span>do<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.8609%;margin-top:-6.5px;left:77.1211%;width:44px;">
      <p class="g-pstyle7">95<span class="g-cstyle3">,</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.7225%;margin-top:-5.8px;left:3.6667%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai1-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:84.5434%;margin-top:-6.9px;left:8.7204%;width:128px;">
      <p class="g-pstyle4"><span class="g-cstyle9">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">rs</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> d<span class="g-cstyle3">e </span>Ch<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a</span>g<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai1-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:84.8749%;margin-top:-6.5px;left:54.4038%;width:85px;">
      <p class="g-pstyle6"><span class="g-cstyle5">E</span>s<span class="g-cstyle5">ta</span>dos<span class="g-cstyle5"> </span><span class="g-cstyle8">U</span>ni<span class="g-cstyle5">d</span>o<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai1-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:84.8749%;margin-top:-6.5px;left:77.1211%;width:42px;">
      <p class="g-pstyle7">9<span class="g-cstyle13">4</span>,<span class="g-cstyle1">5</span></p>
    </div>
    <div id="g-ai1-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:84.7366%;margin-top:-5.8px;left:2.9645%;width:32px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0</p>
    </div>
    <div id="g-ai1-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:91.6266%;margin-top:-7.2px;left:1.6992%;width:241px;">
      <p class="g-pstyle10">(*) <span class="g-cstyle16">F</span>u<span class="g-cstyle3">e</span>nt<span class="g-cstyle3">e</span>: <span class="g-cstyle3">Q</span>S <span class="g-cstyle17">W</span>or<span class="g-cstyle3">ld</span> <span class="g-cstyle9">U</span>ni<span class="g-cstyle3">v</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>t<span class="g-cstyle3">y</span> R<span class="g-cstyle3">a</span>nk<span class="g-cstyle3">i</span>ng<span class="g-cstyle3">s </span>2<span class="g-cstyle3">0</span>2<span class="g-cstyle1">2</span></p>
    </div>
  </div>


</div>
`

const containerId = 'g-02-qs-world-box'
const namespace = 'g-'
const name = '02-qs-world'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-09-14 02:51 */
